<script>
  export let onWheel;

  let eventTries = 0;

  function isScrollable(element) {
    return (
      element.scrollHeight > element.clientHeight ||
      element.scrollWidth > element.clientWidth
    );
  }

  function isAtBottom(element) {
    return element.scrollHeight - element.scrollTop === element.clientHeight;
  }

  function isAtTop(element) {
    return element.scrollTop === 0;
  }

  function handleWheelEvent(event) {
    let target = event.target;
    while (target && target !== document.documentElement) {
      if (isScrollable(target) && target.contains(event.target)) {
        if (
          (event.deltaY > 0 && isAtBottom(target)) ||
          (event.deltaY < 0 && isAtTop(target))
        ) {
          eventTries += 1;
          if (eventTries > 3) {
            eventTries = 0;
            onWheel && onWheel(event);
          }
        }
        return;
      }
      target = target.parentElement;
    }

    onWheel && onWheel(event);
  }

  function setup(node) {
    window.addEventListener("wheel", handleWheelEvent);
    return {
      destroy() {
        window.removeEventListener("wheel", handleWheelEvent);
      },
    };
  }
</script>

<div use:setup />
